const ALERTS_VERBS = {
  CREATED: 'ticket-created',
  ASSIGNED: 'ticket-assigned',
  CANCELLED: 'ticket-cancelled',
  QUOTE_SENT: 'quote-created',
  QUOTE_ACCEPTED: 'quote-accepted',
  QUOTE_EXPIRED: 'quote-expired',
  QUOTE_REJECTED: 'quote-rejected',
  USER_INTEREST_REVALIDATED: 'user-interested',
  DONE: 'ticket-completed',
  NOTIFICATION_SEND_FAILED: 'ticket-notification-send-failed',
  QUOTE_NOTIFICATION_SEND_FAILED: 'quote-notification-send-failed',
  AUCTION_STARTED: 'ticket-auction-started',
  AUCTION_CLOSED: 'ticket-auction-closed',
};

export default ALERTS_VERBS;
